import moment from 'moment'
import getStaticData from '../helpers/getStaticData'
// The language comes in different formats, like: 'en', 'fr-FR', 'nl-NL'
// Moment locales are defined with two characters, like: 'en', 'fr', 'nl'
const language = getStaticData('sitecore').language.substr(0, 2) || 'en'

// default moment locale is 'en'
if (language !== 'en') {
  const locale = require(`moment/locale/${language}`)
  moment.locale(language, locale)
}

export const dateFormat = 'DD-MM-YYYY'

export const dateFormatStringified = 'DD MMM YYYY'

export const stringifyDate = date => date.format(dateFormatStringified)

export default moment
